module.exports = __webpack_public_path__ + "img/logo-viblo-interview.2122bc4d.svg";